export const PROJECT_ID = 'l0whhinj';
export const SANITY_API_VERSION = '2022-03-07';
export const API_VERSION = '2023-01-16';
